import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43b3df42"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "attachmentForm",
    backdrop: "static",
    onHide: _ctx.clearForm,
    onHidden: _ctx.handleHidden
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("เพิ่มเอกสารแนบ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "name",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.name}])
          }, " ชื่อเอกสาร: ", 2),
          (_ctx.submited && _ctx.errors.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาป้อนชื่อเอกสาร "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.name}]),
            placeholder: "กรุณาป้อนชื่อเอกสาร....",
            "aria-label": "name",
            autocomplete: "off",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.formData.name,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            for: "file",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.file}])
          }, " ไฟล์เอกสาร: ", 2),
          (_ctx.submited && _ctx.errors.file)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " * กรุณาเลือกไฟล์เอกสาร "))
            : _createCommentVNode("", true),
          _createElementVNode("input", {
            ref: "fileDialog",
            type: "file",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.file}]),
            disabled: _ctx.isLoading,
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fileDialogChange && _ctx.fileDialogChange(...args)))
          }, null, 42, _hoisted_7)
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_9,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_8),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_11,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_10)
    ]),
    _: 1
  }, 8, ["onHide", "onHidden"]))
}